import Vue from 'vue'
import SocialButtons from '../components/blog/SocialButtons.vue'
import shareIt from 'vue-share-it';
import Faqs from "@/components/Faqs.vue";
import Blog from "@/components/main/Blog.vue";
import VueSlickCarousel from 'vue-slick-carousel'
import Subscribe from "@/components/forms/SubscribeSmall.vue";
Vue.component('VueSlickCarousel', VueSlickCarousel)
Vue.use(shareIt);

let search = document.querySelector('#blog-search')
if (search) {
    search.addEventListener('keyup', (e) => {
        if (e.code === 'Enter') {
            window.location.href = `/blog?search=${search.value}`
        }
    })
}

new Vue({
    render: h => h(SocialButtons)
}).$mount('#social-buttons')

if (faqs) {
    new Vue({
        render: h => h(Faqs,{
            props: {
                faqs: faqs['Pregunta-frecuente']['value'],
                description: faqs['descripcion'] ? faqs['descripcion']['value'] : null,
                title: faqs['titulo'] ? faqs['titulo']['value'] : '<p>Preguntas frecuentes</p>'
            }
        })
    }).$mount('#faqs')
}

new Vue({
    render: h => h(Blog, {
        props: {
            publicationsData: publications,
            smallerCards: true
        }
    })
}).$mount('#related-blogs')

new Vue({
    render: h => h(Subscribe)
}).$mount('#subscribe-small')